module.exports = __webpack_public_path__ + "static/media/license.1e922831.md";